<script lang="ts">
	import '../app.css';
	import '../daisyui.css';
	import { page } from '$app/state';
	import { QueryClient, QueryClientProvider } from '@sveltestack/svelte-query';
	import Hamburger from '$lib/components/header/Hamburger.svelte';
	import MenuSidebar from '$lib/components/header/MenuSidebar.svelte';

	import { menuOpen } from '$lib/stores/ui-store';
	import FullHeader from '$lib/components/header/FullHeader.svelte';
	import { setToastState } from '$lib/components/organisms/toast/toast-state.svelte';
	import Toaster from '$lib/components/organisms/toast/Toaster.svelte';
	import { hideAppLoader } from '$lib/utils/app-loader';
	import { onMount } from 'svelte';

	let { children } = $props();
	import { initToasts } from '$lib/components/organisms/toast/toast';

	// Svelte query default options
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				retry: 0,
				refetchInterval: false,
				refetchOnReconnect: false,
				refetchIntervalInBackground: false,
				refetchOnMount: false,
				refetchOnWindowFocus: false
			}
		}
	});

	//disables scrolling inside number inputs which is a problem in crowded forms. Add as on:wheel per input if supported.
	document.addEventListener('wheel', function () {
		if ((document.activeElement as HTMLInputElement)?.type === 'number') {
			(document.activeElement as HTMLInputElement).blur();
		}
	});

	// Initialize toast state context
	const toastState = setToastState();
	initToasts(toastState);

	// The session resolved and the real UI is up: dismiss the app.html loader.
	onMount(hideAppLoader);
</script>

<QueryClientProvider client={queryClient}>
	<main
		id="mainContainer"
		class="w-screen h-full max-h-full {!['/', '/login', '/map'].includes(page.url.pathname)
			? 'overflow-y-auto overflow-x-hidden'
			: 'overflow-hidden'} relative {$menuOpen ? 'shrink' : ''}"
	>
		<!-- Do not display the navigation bar on the frontpage. Clean up logic when fine-tuning design -->
		{#if !['/', '/login', '/map', '/auth'].includes(page.url.pathname)}
			<!--<Header />-->
			<MenuSidebar />
			<FullHeader />
		{:else if page.url.pathname == '/map'}
			<MenuSidebar />
			<Hamburger floatingPosition={true} />
		{/if}
		{@render children()}
	</main>
</QueryClientProvider>

<Toaster />
